import * as yup from 'yup';

import {$isNG} from '../../../models/utils';
import {TaxesAndTotal} from '../../../types/invoices';

import {isStandartCategory, isZeroCategory} from '../../helpers/consts';

const baseLabelValueSchema = yup
    .object({
        label: yup
            .string()
            .nullable()
            .notRequired(),
        value: yup
            .string()
            .nullable()
            .notRequired(),
    })
    .nullable()
    .notRequired();

const storageLocationAddressShape = baseLabelValueSchema;

function getPath(opts: unknown): string {
    return (opts as {path: string}).path;
}
const calculationsByTaxCategorySchema = (yup.lazy((value, opts) => {
    const path = getPath(opts);

    const index = Number(path.match(/\[(\d+)\]/)?.[1]);

    const {calculationsByTaxCategory} = opts.context as TaxesAndTotal;

    const row = calculationsByTaxCategory[index];
    const {taxCategory} = row;

    const shouldBeRequired =
        !isZeroCategory(taxCategory as string) && !isStandartCategory(taxCategory as string);

    return yup.object({
        taxExemptionReason: shouldBeRequired ? yup.string().required() : yup.string().nullable(),
    });
}) as unknown) as yup.AnySchema;

export const chargesTableSchema = yup.object().shape({
    isRatePercent: yup.boolean(),
    reason: yup.string().required(),
    rate: yup
        .mixed()
        .nullable()
        .when('isRatePercent', {
            is: true,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.nullable(),
        }),
    baseAmount: yup
        .mixed()
        .nullable()
        .when('isRatePercent', {
            is: true,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.nullable(),
        }),
    totalAmount: yup.number().required(),
    vatCategory: storageLocationAddressShape.required(),
    vat: yup.number().required(),
});

export const generalInfoSchema = yup.object().shape({
    calculationsByTaxCategory: yup.array().of(calculationsByTaxCategorySchema),
    lineExtensionAmount: yup.number().nullable(),
    taxExclusiveAmountDisplay: yup.number().nullable(),
    taxInclusiveAmountDisplay: yup.number().nullable(),
    allowanceTotalAmountDisplay: yup.number().nullable(),
    chargeTotalAmountDisplay: yup.number().nullable(),
    prepaidAmount: yup.number().nullable(),
    payableRoundingAmount: yup.number().nullable(),
    payableAmountDisplay: yup.number().nullable(),
    withholdingTax: yup.string().nullable(),
    // allowanceCharge: yup.array().of(chargesTableSchema),
    // taxTotal: yup.string().nullable(),
    // baseAmount: yup.string().nullable(),
    // multiplierFactorNumeric: yup.string().nullable(),
    // whtChargeAmount_1: yup.string().nullable(),
    // taxExclusiveAmount: yup.string().nullable(),
    // taxInclusiveAmount: yup.string().nullable(),
    // payableAmount: yup.string().nullable(),
    // allowanceTotalAmount: yup.string().nullable(),
    // chargeTotalAmount: yup.string().nullable(),
});

type ValidationContext = {
    IS_NG: boolean;
    calculationsByTaxCategory: TaxesAndTotal['calculationsByTaxCategory'];
};

export const createValidationContext = (data: TaxesAndTotal): ValidationContext => ({
    IS_NG: $isNG.getState(),
    calculationsByTaxCategory: data.calculationsByTaxCategory,
});

const resolveFieldSchema = (fieldSchema: any, context: ValidationContext) => {
    if (!fieldSchema) {
        return null;
    }

    if (typeof fieldSchema.resolve === 'function') {
        return fieldSchema.resolve({
            context,
        });
    }

    return fieldSchema;
};

const hasRequiredTest = (schema: any) => {
    if (!schema) {
        return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    const exclusiveTests = schema.exclusiveTests ?? schema._exclusive;
    if (exclusiveTests?.required) {
        return true;
    }

    const tests = schema.tests ?? [];
    return tests.some((test: any) => test?.OPTIONS?.name === 'required');
};

export const createIsFieldRequired = (context: ValidationContext) => {
    const resolvedSchema = generalInfoSchema.resolve({context});

    return (name: string) => {
        const fieldSchema = resolvedSchema.fields[name as keyof typeof resolvedSchema.fields];
        const concreteSchema = resolveFieldSchema(fieldSchema, context);

        return hasRequiredTest(concreteSchema);
    };
};
